<!--  -->
<template>
  <div class="city-popver-checkbox">
    <!-- <el-checkbox-group v-model="all" @change="allChange"> -->
      <div>
        <el-radio-group v-model="provinceRadio" @change="handleRadioChange">
        <el-radio label="1">全选</el-radio>
        <el-radio label="2">全不选</el-radio>
        <el-radio label="3">排除偏远地区</el-radio>
        <el-radio label="4">自定义</el-radio>
      </el-radio-group>
        <span style="margin-left:24px">
          选择<span :style="{'color':'#7F85E9'}">{{areaDataCheck.length}}</span>个地区
        </span>
      </div>
      <hr style="color:#dddddd;margin:20px 0">
    <!-- </el-checkbox-group> -->
    <el-checkbox-group v-model="areaDataCheck" @change="handleCheckedCitiesChange">
        <span
          v-for="(province, index) in area"
          :key="index"
          style="display:inline-block;width:139px; margin-bottom: 10px;"
        >
            <!-- 省 -->

            <el-checkbox
              slot="reference"
              :label="province.name"
            >{{ province.name }}</el-checkbox>
          
        </span>
    </el-checkbox-group>
    <!-- </div> -->
    <div class="btn" style="width:100%; text-align:right;margin-top:50px;">
      <el-button @click="closeDialog(2)" style="width:98px;height:32px;">取消</el-button>
      <el-button @click="closeDialog(1)" style="width:98px;height:32px;" type="primary">确认</el-button>
    </div>
  </div>
</template>

<script>
         
import { getArea } from "@/api/memberLabel";
import { mapState } from "vuex";
let that;
const area = [
        {name:"北京", code:"1"},
         {name:"天津", code:"2"},
         {name:"河北", code:"3"},
         {name:"山西", code:"4"},
         {name:"内蒙古",code: "5"},
         {name:"辽宁", code:"6"},
         {name:"吉林", code:"7"},
         {name:"黑龙江", code:"8"},
         {name:"上海", code:"9"},
         {name:"江苏", code:"10"},
         {name:"浙江", code:"11"},
         {name:"安徽", code:"12"},
         {name:"福建", code:"13"},
         {name:"江西", code:"14"},
         {name:"山东", code:"15"},
         {name:"河南", code:"16"},
         {name:"湖北", code:"17"},
         {name:"湖南", code:"18"},
         {name:"广东", code:"19"},
         {name:"广西", code:"20"},
         {name:"海南", code:"21"},
         {name:"重庆", code:"22"},
         {name:"四川", code:"23"},
         {name:"贵州", code:"24"},
         {name:"云南", code:"25"},
         {name:"西藏", code:"26"},
         {name:"陕西", code:"27"},
         {name:"甘肃", code:"28"},
         {name:"青海", code:"29"},
         {name:"宁夏", code:"30"},
         {name:"新疆", code:"31"},
         {name:"台湾", code:"32"},
         {name:"香港", code:"33"},
         {name:"澳门", code:"34"},
         {name:"海外", code:"35"},]
const RESET_AREA = ["26","25","29","31"]
export default {
  props: {
    checkedList: {
      type: Array,
      default: () => []
    },
    isCityCode:{
      type:Boolean,
      default:false
    }
  },
  watch: {},
  filters: {
    cityLength(v) {
      return v.length <= 4 ? v : v.substr(0, 4) + "...";
    }
  },
  data() {
    return {
      isIndeterminate:false,
      provinceRadio: "4",
      copyCheckList: [],
      area:[],
      areaDataCheck:[],
    };
  },
  computed: {
    ...mapState({
      globalBG: "globalBG",
      //   把city映射给currentCIty
    }),
  },
  created() {
    this.area = area
    this.handleControl();

  },
  beforeCreate: function() {
    that = this;
  },
  methods: {
    allChange(val){
      let cityOptions = area.map(i=>i.name)
      this.areaDataCheck = val ? cityOptions : [];
      this.isIndeterminate = false;
    },

    handleCheckedCitiesChange(val){
      let checkedCount = val.length;
      this.all = checkedCount === this.area.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.area.length;
      if (checkedCount > 0 && checkedCount < this.area.length) {
        this.provinceRadio = '4'
      }else if (checkedCount > 0 && checkedCount == this.area.length) {
         this.provinceRadio = '1'
      }
    },
    closeDialog(v) {
      this.$emit("closeFn", v);
      if(v===2){
        this.handleControl()
      }
    },

    init() {
      getArea().then(res => {
        if (res.code === 1) {
          console.log(res.data);
          // return
          // 格式化数据
          res.data.forEach(item => {
            item.checked = false;
            item.indeterminate = false;
            item.model = item.name;
            item.arr = [];
            item.parent = this.areaData;
            // 省份
            item.children.forEach(province => {
              province.checked = false;
              province.indeterminate = false;
              province.arr = [];
              province.checkTotal = 0;
              province.model = province.name;
              province.type = 'sheng';
              province.parent = item;
              // 城市
              province.children.forEach(city => {
                city.model = city.title;
                city.checked = false;
                city.parent = province;
              });
              province.children = province.children;
            });
            item.children = item.children;
          });
          this.areaData.children = res.data;
          // console.log(this.areaData);
          this.areaLastList = this.getLast(this.areaData);
          // console.log(this.areaData.children);
        }
      });
    },
    handleRadioChange(val) {
      switch (val) {
        case "1":
          this.allChange(val)
          break;
        case "2":
          this.areaDataCheck = [];
          break;
        case "3":
          let arr = []
          area.forEach(item => {
            
            if(!RESET_AREA.includes(item.code)){
              arr.push(item.name)
            }
          }
          );
          console.log(arr)
          this.areaDataCheck = arr
          break;
        case "4":
          break;
      }
    },


    handleCheckChange(list, val) {
      const arr = this.getLast(list);     //获取城市
      // console.log(arr);
      arr.forEach(item => {
        this.handleCityChange(item, val);
      });
      this.checkTotle();
    },


    handleCountChange(list) {
      // console.log(list);
      if (!list.children) return false;
      const count = list.children.reduce((prev, item) => {
        return (prev += item.checked ? 1 : 0);
      }, 0);
      const arrLen = list.children.length;
      list.checked = count > 0;
      list.indeterminate = count > 0 && list.arr.length < arrLen;
      if (list.parent) {
        const arr = list.parent.arr;
        const index = arr.findIndex(item => item === list.model);
        if (count === list.children.length) {
          if (index === -1) arr.push(list.model);
        } else {
          if (index !== -1) arr.splice(index, 1);
        }
        this.handleCountChange(list.parent);
      }
    },
    // 城市勾选
    handleCityChange(city, checked, i, k) {
      // console.log(city);
      city.checked = checked;
      const arr = [];
      city.parent.children.forEach(item => {
        item.checked && arr.push(item.model);
      });
      city.parent.arr = arr;
      // console.log(city.parent);
      this.handleCountChange(city.parent);

      // 省级选框后的已选数
      if (i || k || i == 0 || k == 0) {
        this.areaData.children[i].children.forEach((item, index) => {
          // console.log(item);
          item.checkTotal = 0;
          item.children.forEach((itemA, indexA) => {
            if (itemA.checked) {
              item.checkTotal = item.checkTotal + 1;
            }
          });
        });
      }
    },

    // 城市选择totle
    checkTotle() {
      this.areaData.children.forEach((item, index) => {
        item.children.forEach((itemA, indexA) => {
          itemA.checkTotal = 0;
          itemA.children.forEach((itemB, indexB) => {
            if (itemB.checked) {
              itemA.checkTotal = itemA.checkTotal + 1;
            }
          });
        });
      });
    },
    // 回现
    handleControl() {
      let copyCheckList = [];
      console.log( this.checkedList);
      for(let i=0;i<this.checkedList.length;i++){
        this.checkedList[i] +='' 
      }
      try {
        if(this.isCityCode){
          let res = []
          this.area.forEach(i=>{
            if(this.checkedList.includes(i.code)){
              res.push(i.name)
            }
          })
          console.log(res);
          this.areaDataCheck = res;
        }
        else{
          this.areaDataCheck = this.checkedList;
        }
    
      } catch (e) {}
    },
    // 获取最子集合
    getLast(obj) {
      const res = [];
      obj.children.forEach(item => {
        if (item.children) {
          res.push(...this.getLast(item));
        } else {
          res.push(item);
        }
      });
      return res;
    },
    getResult() {
      const arr = this.areaDataCheck;
      if(this.isCityCode){
        let res = []
        this.area.forEach(i=>{
          if(arr.includes(i.name)){
            res.push(i.code)
          }
        })
        return res
      }
      return arr;
    }
  }
};
</script>
<style lang='scss' scoped>
.dialog-header {
  margin-bottom: 20px;
}
.headler-label {
  font-size: 16px;
  margin-right: 30px;
}
</style>